export default {
	"order.NoActivationAddress": "No activation address!",
	"order.PleaseTryAgainLater": "Please try again later",
	"order.toFillInTheShippingAddress": "to fill in the shipping address",
	"order.deactivateProduct": "deactivate product",
	"order.paymentSuccessful": "payment successful"
}